/* Novaris mobile sticky purchase flow — product page only.
 * v1.10.0 — v58: direct card selection, explicit preview label and itemized total.
 *
 * - Sticky CTA appears whenever the native buy button is outside the viewport.
 * - Bottom sheet uses an INDEPENDENT Shopify variant selector.
 * - It does not move/clone/inspect Variant Image Wizard's visual picker.
 * - Variant IDs, availability, prices and images come from Shopify product JSON.
 * - Adding opens the cart; the sticky keeps the “Elegir opciones” action.
 */
(function () {
  'use strict';
  if (window.NovarisMobileStickyBuy) return;

  var mq = window.matchMedia('(max-width: 768px)');
  var activeSheet = null;
  var activeTrigger = null;
  var closeTimer = 0;
  var cartDrawerObserver = null;
  var pendingNativeBar = null;
  var pendingNativeButton = null;

  function visibleCartTrigger() {
    var links = Array.prototype.slice.call(document.querySelectorAll('a.js-drawer-open-cart'));
    return links.find(function (el) {
      if (!el || !el.isConnected) return false;
      var rect = el.getBoundingClientRect();
      var style = window.getComputedStyle(el);
      return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden';
    }) || links[0] || null;
  }

  function setBarCartState(bar) {
    if (!bar) return;
    var trigger = bar.querySelector('[data-nv-mobile-buybar-open]');
    if (!trigger) return;
    trigger.removeAttribute('data-nv-mobile-action');
    trigger.textContent = 'Elegir opciones';
    trigger.setAttribute('aria-controls', bar.getAttribute('data-nv-options-target') || '');
    trigger.setAttribute('aria-expanded', 'false');
  }


  function resetBarCartState(bar) {
    if (!bar) return;
    var trigger = bar.querySelector('[data-nv-mobile-buybar-open]');
    if (!trigger || trigger.getAttribute('data-nv-mobile-action') !== 'cart') return;
    var original = trigger.getAttribute('data-nv-original-label');
    var originalControls = trigger.getAttribute('data-nv-original-controls');
    trigger.removeAttribute('data-nv-mobile-action');
    if (original) trigger.textContent = original;
    if (originalControls) trigger.setAttribute('aria-controls', originalControls);
    else trigger.removeAttribute('aria-controls');
  }

  function syncCartDrawerState() {
    var drawer = document.getElementById('CartDrawer');
    var isOpen = !!(drawer && drawer.classList.contains('drawer--is-open'));
    document.documentElement.classList.toggle('nv-cart-drawer-open', isOpen);
  }

  function initCartDrawerWatcher() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer || cartDrawerObserver) {
      syncCartDrawerState();
      return;
    }

    syncCartDrawerState();
    cartDrawerObserver = new MutationObserver(syncCartDrawerState);
    cartDrawerObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  function visible(el) {
    if (!el || !el.isConnected) return false;
    var style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden' && !!el.getClientRects().length;
  }

  function getProductSection(sheet) {
    var id = sheet && sheet.getAttribute('data-nv-product-section');
    return id ? document.getElementById(id) : null;
  }

  function getNativeForm(sheet) {
    var section = getProductSection(sheet);
    return section ? section.querySelector('form.product-single__form') : null;
  }

  function getVariants(sheet) {
    if (!sheet) return [];
    if (sheet._nvVariants) return sheet._nvVariants;
    var node = sheet.querySelector('[data-nv-mobile-variants]');
    if (!node) return [];
    try {
      sheet._nvVariants = JSON.parse(node.textContent || '[]');
    } catch (error) {
      sheet._nvVariants = [];
    }
    return sheet._nvVariants;
  }

  function nativeVariantId(sheet) {
    var section = getProductSection(sheet);
    var groups = section ? Array.prototype.slice.call(section.querySelectorAll('.variant-wrapper')) : [];
    var values = groups.map(function (group) {
      var input = group.querySelector('input:checked, select');
      return input ? String(input.value) : null;
    });
    var match = values.length && values.every(function (value) { return value !== null; }) &&
      getVariants(sheet).find(function (variant) {
        return variant.options && variant.options.length === values.length && values.every(function (value, i) {
          return String(variant.options[i]) === value;
        });
      });
    if (match) return String(match.id);
    var form = getNativeForm(sheet);
    var select = form && form.querySelector('[data-product-select], [name="id"]');
    return select ? String(select.value || '') : '';
  }


  function getSelectedValues(sheet) {
    var groups = Array.prototype.slice.call(sheet.querySelectorAll('[data-nv-option-group]'));
    return groups.map(function (group) {
      var selected = group.querySelector('[data-nv-option-value].is-selected');
      return selected ? selected.getAttribute('data-value') : null;
    });
  }

  function findVariant(sheet, selectedValues) {
    var variants = getVariants(sheet);
    if (!variants.length) return null;
    if (!selectedValues) selectedValues = getSelectedValues(sheet);

    if (!selectedValues.length) {
      return variants.find(function (variant) { return variant.available; }) || variants[0] || null;
    }

    return variants.find(function (variant) {
      if (!variant.options || variant.options.length !== selectedValues.length) return false;
      return selectedValues.every(function (value, index) {
        return String(variant.options[index]) === String(value);
      });
    }) || null;
  }

  function setSheetSelectionFromVariant(sheet, variant) {
    if (!sheet || !variant || !variant.options) return;
    sheet.querySelectorAll('[data-nv-option-group]').forEach(function (group) {
      var index = parseInt(group.getAttribute('data-option-index'), 10);
      var value = variant.options[index];
      group.querySelectorAll('[data-nv-option-value]').forEach(function (button) {
        var selected = String(button.getAttribute('data-value')) === String(value);
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    });
  }

  function hasMultiVariantUI(sheet) {
    return !!(sheet && sheet.querySelector('[data-nv-mobile-multi-variants]'));
  }

  function getMultiRows(sheet) {
    return sheet ? Array.prototype.slice.call(sheet.querySelectorAll('[data-nv-mobile-multi-variant]')) : [];
  }

  function variantById(sheet, id) {
    return getVariants(sheet).find(function (variant) { return String(variant.id) === String(id); }) || null;
  }

  function clampMultiQuantity(input) {
    if (!input) return 1;
    var qty = Math.floor(Number(input.value));
    if (!isFinite(qty) || qty < 1 || qty > Number.MAX_SAFE_INTEGER) qty = 1;
    input.value = String(qty);
    return qty;
  }

  function multiIsBusy(sheet) {
    var add = sheet && sheet.querySelector('[data-nv-sheet-add]');
    return !!(sheet && (sheet._nvMultiCompleted || (add && add.getAttribute('aria-busy') === 'true')));
  }

  function selectedMultiEntries(sheet) {
    return getMultiRows(sheet).filter(function (row) {
      return row.classList.contains('is-selected') && row.getAttribute('data-available') === 'true';
    }).map(function (row) {
      var variant = variantById(sheet, row.getAttribute('data-variant-id'));
      var quantity = clampMultiQuantity(row.querySelector('[data-nv-mobile-multi-qty]'));
      return variant && variant.available ? { row: row, variant: variant, quantity: quantity } : null;
    }).filter(Boolean);
  }

  function setMultiRowSelected(sheet, row, selected) {
    if (!sheet || !row) return;
    selected = !!selected && row.getAttribute('data-available') === 'true';
    var wasSelected = row.classList.contains('is-selected');
    row.classList.toggle('is-selected', selected);
    var toggle = row.querySelector('[data-nv-mobile-multi-toggle]');
    if (toggle) toggle.setAttribute('aria-checked', selected ? 'true' : 'false');
    var quantity = row.querySelector('[data-nv-mobile-multi-quantity]');
    if (quantity) quantity.hidden = !selected;
    var input = row.querySelector('[data-nv-mobile-multi-qty]');
    // A newly checked option starts at one; deselecting only removes the
    // pending selection. It never removes anything from the existing cart.
    if (input && (!selected || !wasSelected)) input.value = '1';
  }

  // Changing the main gallery photo does not modify pending quantities.
  // _nvLastMultiVariantId is the PREVIEW, not the set of items to buy.
  function previewMultiRow(sheet, row, behavior) {
    if (!sheet || !row || multiIsBusy(sheet)) return;
    var variant = variantById(sheet, row.getAttribute('data-variant-id'));
    if (!variant) return;
    sheet._nvLastMultiVariantId = String(variant.id);
    syncMobileCarouselToVariant(sheet, variant, behavior || 'smooth');
    updateMultiState(sheet);
  }

  // Friendly display names only; Shopify variant IDs and values remain unchanged.
  function selectionLabel(variant) {
    var title = String(variant && variant.title || '');
    var key = title.replace(/^\d+\s+/, '').trim().toUpperCase();
    var colors = { 'BLACK': 'Negro', 'BROWN': 'Marrón', 'BLUE': 'Azul', 'DARK BEIGE': 'Beige oscuro', 'GREEN': 'Verde', 'RED': 'Rojo', 'BLACK RED': 'Negro / Rojo' };
    return colors[key] || title;
  }

  function updateMultiState(sheet) {
    var entries = selectedMultiEntries(sheet);
    var totalQty = entries.reduce(function (sum, entry) { return sum + entry.quantity; }, 0);
    var viewedVariant = variantById(sheet, sheet._nvLastMultiVariantId) || (entries.length ? entries[entries.length - 1].variant : null);
    var price = sheet.querySelector('[data-nv-sheet-price]');
    // Header price is always the UNIT price of the last previewed variant,
    // never the combined price or quantity of the checked options.
    if (price && viewedVariant) price.textContent = formatMoney(viewedVariant.price);
    var busy = multiIsBusy(sheet);
    var add = sheet.querySelector('[data-nv-sheet-add]');
    var addText = sheet.querySelector('[data-nv-sheet-add-text]');
    var emptyText = add && add.getAttribute('data-multi-empty-text');
    if (add) add.disabled = !entries.length || busy;
    if (addText) addText.textContent = totalQty > 0
      ? 'Quiero Pedirlo'
      : (emptyText || 'Selecciona al menos una opción');
    var summary = sheet.querySelector('[data-nv-mobile-multi-summary]');
    var totalPrice = entries.reduce(function (sum, entry) { return sum + Number(entry.variant.price) * entry.quantity; }, 0);
    if (summary) summary.textContent = entries.length
      ? (entries.map(function (entry) { return selectionLabel(entry.variant) + ' × ' + entry.quantity; }).join(' · ') + ' | Total: ' + formatMoney(totalPrice))
      : 'Elige una o varias opciones para continuar.';
    var viewedLabel = sheet.querySelector('[data-nv-mobile-viewed-label]');
    if (viewedLabel && viewedVariant) viewedLabel.textContent = 'Foto: ' + selectionLabel(viewedVariant) + ' · Precio por unidad';
    getMultiRows(sheet).forEach(function (row) {
      var selected = row.classList.contains('is-selected') && row.getAttribute('data-available') === 'true';
      row.classList.toggle('is-previewed', String(row.getAttribute('data-variant-id') || '') === String(sheet._nvLastMultiVariantId || ''));
      var toggle = row.querySelector('[data-nv-mobile-multi-toggle]');
      if (toggle) toggle.disabled = row.getAttribute('data-available') !== 'true' || busy;
      var preview = row.querySelector('[data-nv-mobile-multi-preview]');
      if (preview) {
        preview.disabled = busy;
        var rowVariant = variantById(sheet, row.getAttribute('data-variant-id'));
        preview.setAttribute('aria-pressed', selected ? 'true' : 'false');
        preview.setAttribute('aria-label', (row.getAttribute('data-available') !== 'true' ? 'Ver ' : (selected ? 'Quitar ' : 'Elegir ')) + selectionLabel(rowVariant) + (row.getAttribute('data-available') !== 'true' ? ' - Agotado' : ''));
      }
      var group = row.querySelector('[data-nv-mobile-multi-quantity]');
      if (group) {
        group.hidden = !selected;
        group.querySelectorAll('button, input').forEach(function (control) { control.disabled = !selected || busy; });
      }
      var minus = row.querySelector('[data-nv-mobile-multi-qty-minus]');
      var input = row.querySelector('[data-nv-mobile-multi-qty]');
      if (minus) minus.disabled = !selected || busy || Number(input && input.value) <= 1;
    });
    return entries;
  }

  function syncMultiFromNative(sheet) {
    var rows = getMultiRows(sheet);
    if (!rows.length) return false;
    // Do not reset an in-flight request when the visitor closes and reopens.
    var add = sheet.querySelector('[data-nv-sheet-add]');
    if (add && add.getAttribute('aria-busy') === 'true') return false;
    sheet._nvMultiCompleted = false;
    var currentId = nativeVariantId(sheet);
    var current = variantById(sheet, currentId);
    if (!current) current = getVariants(sheet).find(function (variant) { return variant.available; }) || getVariants(sheet)[0] || null;
    var section = getProductSection(sheet);
    // Carry the variant already shown on every product page, including catalog
    // links without a variant parameter. Sold-out variants remain unselected.
    var carryCurrentChoice = !!(section && current && current.available);
    rows.forEach(function (row) {
      var input = row.querySelector('[data-nv-mobile-multi-qty]');
      if (input) input.value = '1';
      var selected = carryCurrentChoice && String(current.id) === row.getAttribute('data-variant-id');
      setMultiRowSelected(sheet, row, selected);
      if (selected && input) {
        var quantity = section.querySelector('.product__quantity input[name="quantity"]');
        input.value = String(Math.max(1, parseInt(quantity && quantity.value, 10) || 1));
      }
    });
    sheet._nvLastMultiVariantId = current ? String(current.id) : '';
    if (current) syncMobileCarouselToVariant(sheet, current, 'auto');
    updateMultiState(sheet);
    return true;
  }

  function toggleMultiRow(sheet, row) {
    if (!sheet || !row || row.getAttribute('data-available') !== 'true' || multiIsBusy(sheet)) return;
    // Both the option card and its checkbox toggle the same pending selection.
    var selected = !row.classList.contains('is-selected');
    setMultiRowSelected(sheet, row, selected);
    if (selected) previewMultiRow(sheet, row, 'smooth');
    setSheetError(sheet, '');
    updateMultiState(sheet);
  }

  function changeMultiQuantity(sheet, row, delta) {
    if (!sheet || !row || !row.classList.contains('is-selected') || multiIsBusy(sheet)) return;
    var input = row.querySelector('[data-nv-mobile-multi-qty]');
    if (!input) return;
    input.value = String(Math.max(1, clampMultiQuantity(input) + delta));
    clampMultiQuantity(input);
    setSheetError(sheet, '');
    updateMultiState(sheet);
  }

  function addMultipleFromSheet(sheet, button) {
    if (!sheet || !button || multiIsBusy(sheet)) return;
    var entries = updateMultiState(sheet);
    if (!entries.length) {
      setSheetError(sheet, 'Selecciona al menos una opción.');
      return;
    }

    var items = entries.map(function (entry) {
      return { id: String(entry.variant.id), quantity: entry.quantity };
    });

    button.setAttribute('aria-busy', 'true');
    button.classList.add('btn--loading');
    button.disabled = true;
    setSheetError(sheet, '');
    updateMultiState(sheet);

    var route = (window.theme && theme.routes && theme.routes.cartAdd) || ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/add.js';
    fetch(route, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        return response.json().then(function (payload) {
          if (!response.ok || (payload && payload.status === 422)) {
            var error = new Error(payload.description || payload.message || 'No se pudieron agregar los productos.');
            error.payload = payload;
            throw error;
          }
          return payload;
        });
      })
      .then(function (payload) {
        sheet._nvMultiCompleted = true;
        // Also update the sticky if the dialog was manually closed mid-request.
        var completedBar = document.querySelector('[data-nv-mobile-buybar][data-nv-options-target="' + sheet.id + '"]');
        setBarCartState(completedBar);
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: payload,
            addToCartBtn: button,
            novarisVariantIds: items.map(function (item) { return item.id; })
          }
        }));
      })
      .catch(function (error) {
        var message = (error && error.payload && error.payload.description) || error.message || 'No se pudieron agregar los productos.';
        setSheetError(sheet, message);
        document.dispatchEvent(new CustomEvent('ajaxProduct:error', { detail: { errorMessage: message } }));
      })
      .finally(function () {
        button.removeAttribute('aria-busy');
        button.classList.remove('btn--loading');
        if (sheet === activeSheet) updateMultiState(sheet);
      });
  }

  function mobileCarouselParts(sheet) {
    if (!sheet) return null;
    var viewport = sheet.querySelector('[data-nv-mobile-carousel-viewport]');
    if (!viewport) return null;
    return {
      viewport: viewport,
      slides: Array.prototype.slice.call(sheet.querySelectorAll('[data-nv-mobile-carousel-slide]')),
      current: sheet.querySelector('[data-nv-mobile-carousel-current]'),
      total: sheet.querySelector('[data-nv-mobile-carousel-total]'),
      prev: sheet.querySelector('[data-nv-mobile-carousel-prev]'),
      next: sheet.querySelector('[data-nv-mobile-carousel-next]')
    };
  }

  function mobileVisibleCarouselSlides(parts) {
    if (!parts) return [];
    return parts.slides.filter(function (slide) { return !slide.hidden; });
  }

  function variantFeaturedImageId(variant) {
    if (!variant || !variant.featured_image) return '';
    return String(variant.featured_image.id || '');
  }

  // v57 — infer variant photo groups from Shopify's existing media order.
  // Each unique variant featured image marks the beginning of a group; that
  // group runs until the next variant featured image. If there are not at
  // least two reliable group markers, keep every photo visible as a fallback.
  function mobileVariantImageRange(sheet, variant) {
    var parts = mobileCarouselParts(sheet);
    if (!parts || !parts.slides.length || !variant) return null;
    var imageId = variantFeaturedImageId(variant);
    if (!imageId) return null;
    var imageIndex = parts.slides.findIndex(function (slide) {
      return String(slide.getAttribute('data-image-id') || '') === imageId;
    });
    if (imageIndex < 0) return null;

    var starts = [];
    getVariants(sheet).forEach(function (item) {
      var id = variantFeaturedImageId(item);
      if (!id) return;
      var index = parts.slides.findIndex(function (slide) {
        return String(slide.getAttribute('data-image-id') || '') === id;
      });
      if (index >= 0 && starts.indexOf(index) === -1) starts.push(index);
    });
    starts.sort(function (a, b) { return a - b; });
    if (starts.length < 2 || starts.indexOf(imageIndex) === -1) return null;
    var position = starts.indexOf(imageIndex);
    return {
      start: imageIndex,
      end: position + 1 < starts.length ? starts[position + 1] : parts.slides.length,
      key: imageIndex + ':' + (position + 1 < starts.length ? starts[position + 1] : parts.slides.length)
    };
  }

  function updateMobileCarouselChrome(sheet) {
    var parts = mobileCarouselParts(sheet);
    if (!parts) return;
    var visible = mobileVisibleCarouselSlides(parts);
    var count = visible.length || parts.slides.length;
    if (parts.total) parts.total.textContent = String(count);
    if (parts.prev) parts.prev.hidden = count <= 1;
    if (parts.next) parts.next.hidden = count <= 1;
    var carousel = sheet.querySelector('[data-nv-mobile-carousel]');
    if (carousel) carousel.setAttribute('data-nv-visible-images', String(count));
  }

  function applyMobileVariantImageGroup(sheet, variant) {
    var parts = mobileCarouselParts(sheet);
    if (!parts) return { filtered: false, imageIndex: -1 };
    var range = mobileVariantImageRange(sheet, variant);
    parts.slides.forEach(function (slide, index) {
      slide.hidden = !!range && (index < range.start || index >= range.end);
    });
    parts.viewport.dataset.nvVariantImageGroup = range ? range.key : 'all';
    updateMobileCarouselChrome(sheet);
    return { filtered: !!range, imageIndex: range ? 0 : -1 };
  }

  function mobileCarouselIndex(sheet) {
    var parts = mobileCarouselParts(sheet);
    var visible = mobileVisibleCarouselSlides(parts);
    if (!parts || !visible.length) return 0;
    var viewport = parts.viewport;
    var width = viewport.clientWidth || 1;
    return Math.max(0, Math.min(visible.length - 1, Math.round(viewport.scrollLeft / width)));
  }

  // v51 — double tap opens a separate fullscreen lightbox, instead
  // of zooming inside the selector itself. The selector remains underneath and
  // keeps its preview, selected checkboxes and quantities intact.
  function resetMobileCarouselZoom(sheet) {
    var parts = mobileCarouselParts(sheet);
    if (!parts) return;
    // v56: there is no in-place zoom anymore. Only reset double-tap tracking.
    parts.viewport._nvLastTapTime = 0;
    parts.viewport._nvLastTapX = 0;
    parts.viewport._nvLastTapY = 0;
    parts.viewport._nvLastTapSlide = null;
  }

  function mobileLightboxParts(sheet) {
    if (!sheet) return null;
    var root = sheet.querySelector('[data-nv-mobile-lightbox]');
    var viewport = root && root.querySelector('[data-nv-mobile-lightbox-viewport]');
    if (!root || !viewport) return null;
    return {
      root: root,
      viewport: viewport,
      slides: Array.prototype.slice.call(root.querySelectorAll('[data-nv-mobile-lightbox-slide]')),
      current: root.querySelector('[data-nv-mobile-lightbox-current]'),
      total: root.querySelector('[data-nv-mobile-lightbox-total]')
    };
  }

  function buildMobileLightboxSlides(sheet) {
    var lb = mobileLightboxParts(sheet);
    var carousel = mobileCarouselParts(sheet);
    if (!lb || !carousel) return lb;
    var visible = mobileVisibleCarouselSlides(carousel);
    var key = visible.map(function (slide) { return slide.getAttribute('data-image-id') || ''; }).join('|');
    if (lb.viewport.dataset.nvLightboxBuiltKey === key && lb.slides.length === visible.length) return lb;

    lb.viewport.innerHTML = '';
    var fragment = document.createDocumentFragment();
    visible.forEach(function (sourceSlide, index) {
      var sourceImage = sourceSlide.querySelector('img');
      if (!sourceImage) return;

      var figure = document.createElement('figure');
      figure.className = 'nv-mobile-lightbox__slide';
      figure.setAttribute('data-nv-mobile-lightbox-slide', '');
      var imageId = sourceSlide.getAttribute('data-image-id');
      if (imageId) figure.setAttribute('data-image-id', imageId);

      var image = document.createElement('img');
      image.alt = sourceImage.alt || '';
      image.width = 1200;
      image.height = 1200;
      image.loading = index === 0 ? 'eager' : 'lazy';
      image.decoding = 'async';
      image.src = sourceImage.getAttribute('data-nv-lightbox-src') || sourceImage.currentSrc || sourceImage.src;
      figure.appendChild(image);
      fragment.appendChild(figure);
    });

    lb.viewport.appendChild(fragment);
    lb.viewport.dataset.nvLightboxBuiltKey = key;
    lb = mobileLightboxParts(sheet);
    if (lb && lb.total) lb.total.textContent = String(lb.slides.length);
    return lb;
  }

  function mobileLightboxIndex(sheet) {
    var parts = mobileLightboxParts(sheet);
    if (!parts || !parts.slides.length) return 0;
    var width = parts.viewport.clientWidth || 1;
    return Math.max(0, Math.min(parts.slides.length - 1, Math.round(parts.viewport.scrollLeft / width)));
  }

  function setMobileLightboxIndex(sheet, index, behavior) {
    var parts = mobileLightboxParts(sheet);
    if (!parts || !parts.slides.length) return;
    index = Math.max(0, Math.min(parts.slides.length - 1, Number(index) || 0));
    parts.viewport.dataset.nvLightboxTarget = String(index);
    if (parts.current) parts.current.textContent = String(index + 1);
    if (parts.total) parts.total.textContent = String(parts.slides.length);
    var slide = parts.slides[index];
    if (!slide) return;
    parts.viewport.scrollTo({ left: slide.offsetLeft, behavior: behavior || 'auto' });
  }

  function refreshMobileLightboxCounter(sheet) {
    var parts = mobileLightboxParts(sheet);
    if (!parts) return;
    var index = mobileLightboxIndex(sheet);
    parts.viewport.dataset.nvLightboxTarget = String(index);
    if (parts.current) parts.current.textContent = String(index + 1);
    if (parts.total) parts.total.textContent = String(parts.slides.length);
  }

  function openMobileLightbox(sheet, startIndex) {
    var parts = buildMobileLightboxSlides(sheet);
    if (!parts || !parts.slides.length) return;
    parts.root.hidden = false;
    parts.root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('nv-mobile-lightbox-open');
    var panel = sheet.querySelector('.nv-mobile-options-sheet__panel');
    if (panel) panel.classList.add('nv-lightbox-open');
    setMobileLightboxIndex(sheet, startIndex, 'auto');
  }

  function closeMobileLightbox(sheet) {
    var parts = mobileLightboxParts(sheet);
    if (!parts) return;
    parts.root.hidden = true;
    parts.root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('nv-mobile-lightbox-open');
    var panel = sheet.querySelector('.nv-mobile-options-sheet__panel');
    if (panel) panel.classList.remove('nv-lightbox-open');
  }

  function initMobileLightbox(sheet) {
    var parts = mobileLightboxParts(sheet);
    if (!parts || parts.viewport.dataset.nvLightboxReady === 'true') return;
    parts.viewport.dataset.nvLightboxReady = 'true';
    var ticking = false;
    parts.viewport.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        refreshMobileLightboxCounter(sheet);
        ticking = false;
      });
    }, { passive: true });
  }

  function setMobileCarouselIndex(sheet, index, behavior) {
    var parts = mobileCarouselParts(sheet);
    var visible = mobileVisibleCarouselSlides(parts);
    if (!parts || !visible.length) return;
    resetMobileCarouselZoom(sheet);
    index = Math.max(0, Math.min(visible.length - 1, Number(index) || 0));
    parts.viewport.dataset.nvCarouselTarget = String(index);
    if (parts.current) parts.current.textContent = String(index + 1);
    if (parts.total) parts.total.textContent = String(visible.length);
    if (!parts.viewport.clientWidth) return;
    var slide = visible[index];
    parts.viewport.scrollTo({ left: slide.offsetLeft, behavior: behavior || 'smooth' });
  }

  function refreshMobileCarouselCounter(sheet) {
    var parts = mobileCarouselParts(sheet);
    var visible = mobileVisibleCarouselSlides(parts);
    if (!parts || !visible.length) return;
    var index = mobileCarouselIndex(sheet);
    parts.viewport.dataset.nvCarouselTarget = String(index);
    if (parts.current) parts.current.textContent = String(index + 1);
    if (parts.total) parts.total.textContent = String(visible.length);
  }

  function initMobileCarousel(sheet) {
    var parts = mobileCarouselParts(sheet);
    if (!parts || parts.viewport.dataset.nvCarouselReady === 'true') return;
    parts.viewport.dataset.nvCarouselReady = 'true';
    var ticking = false;
    parts.viewport.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        refreshMobileCarouselCounter(sheet);
        ticking = false;
      });
    }, { passive: true });

    var touchStartX = 0;
    var touchStartY = 0;
    parts.viewport.addEventListener('touchstart', function (event) {
      if (!event.touches || event.touches.length !== 1) return;
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
    }, { passive: true });

    parts.viewport.addEventListener('touchend', function (event) {
      if (!event.changedTouches || event.changedTouches.length !== 1) return;
      var touch = event.changedTouches[0];
      var moved = Math.hypot(touch.clientX - touchStartX, touch.clientY - touchStartY);
      if (moved > 14) {
        parts.viewport._nvLastTapTime = 0;
        return;
      }

      var target = document.elementFromPoint(touch.clientX, touch.clientY);
      var slide = target && target.closest ? target.closest('[data-nv-mobile-carousel-slide]') : null;
      if (!slide || !parts.viewport.contains(slide) || slide.hidden) return;

      var now = Date.now();
      var sameSlide = parts.viewport._nvLastTapSlide === slide;
      var closeEnough = Math.hypot(
        touch.clientX - (parts.viewport._nvLastTapX || 0),
        touch.clientY - (parts.viewport._nvLastTapY || 0)
      ) <= 42;
      var isDoubleTap = sameSlide && closeEnough && (now - (parts.viewport._nvLastTapTime || 0) <= 340);

      if (isDoubleTap) {
        event.preventDefault();
        var visible = mobileVisibleCarouselSlides(parts);
        var index = visible.indexOf(slide);
        openMobileLightbox(sheet, index < 0 ? mobileCarouselIndex(sheet) : index);
        parts.viewport._nvLastTapTime = 0;
        parts.viewport._nvLastTapSlide = null;
      } else {
        parts.viewport._nvLastTapTime = now;
        parts.viewport._nvLastTapX = touch.clientX;
        parts.viewport._nvLastTapY = touch.clientY;
        parts.viewport._nvLastTapSlide = slide;
      }
    }, { passive: false });
  }

  function setMobileCarouselVariantCode(sheet, variant) {
    if (!sheet) return;
    var label = sheet.querySelector('[data-nv-mobile-carousel-variant-code]');
    if (!label) return;
    var text = variant && variant.title && variant.title !== 'Default Title' ? String(variant.title) : '';
    label.textContent = text;
    label.hidden = !text;
  }

  function syncMobileCarouselToVariant(sheet, variant, behavior) {
    var parts = mobileCarouselParts(sheet);
    if (!parts || !parts.slides.length) return;
    setMobileCarouselVariantCode(sheet, variant);
    var group = applyMobileVariantImageGroup(sheet, variant);
    var visible = mobileVisibleCarouselSlides(parts);
    var imageId = variantFeaturedImageId(variant);
    var index = 0;
    if (!group.filtered && imageId) {
      index = visible.findIndex(function (slide) {
        return String(slide.getAttribute('data-image-id') || '') === imageId;
      });
      if (index < 0) index = 0;
    }
    setMobileCarouselIndex(sheet, index, behavior || 'smooth');
  }

  function moveMobileCarousel(sheet, delta) {
    var parts = mobileCarouselParts(sheet);
    var visible = mobileVisibleCarouselSlides(parts);
    if (!parts || !visible.length) return;
    setMobileCarouselIndex(sheet, mobileCarouselIndex(sheet) + delta, 'smooth');
  }

  function formatMoney(cents) {
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(cents, theme.settings && theme.settings.moneyFormat);
    }
    return 'S/. ' + (Number(cents || 0) / 100).toFixed(2);
  }

  function setSheetError(sheet, message) {
    var error = sheet && sheet.querySelector('[data-nv-sheet-error]');
    if (!error) return;
    if (message) {
      error.textContent = message;
      error.hidden = false;
    } else {
      error.textContent = '';
      error.hidden = true;
    }
  }

  function candidateAvailable(variants, selections, optionIndex, candidateValue) {
    // Match Shopify's usual progressive option logic: a value is selectable
    // when an available variant exists for that value plus the options that
    // precede it. Later option choices must not create a dead-end.
    return variants.some(function (variant) {
      if (!variant.available || !variant.options) return false;
      if (String(variant.options[optionIndex]) !== String(candidateValue)) return false;
      for (var index = 0; index < optionIndex; index += 1) {
        var value = selections[index];
        if (value !== null && typeof value !== 'undefined' && String(variant.options[index]) !== String(value)) {
          return false;
        }
      }
      return true;
    });
  }

  function updateSheetState(sheet) {
    if (!sheet) return null;
    if (hasMultiVariantUI(sheet)) {
      updateMultiState(sheet);
      var last = sheet._nvLastMultiVariantId && variantById(sheet, sheet._nvLastMultiVariantId);
      return last || null;
    }
    var variants = getVariants(sheet);
    var selections = getSelectedValues(sheet);
    var variant = findVariant(sheet, selections);

    sheet.querySelectorAll('[data-nv-option-group]').forEach(function (group) {
      var optionIndex = parseInt(group.getAttribute('data-option-index'), 10);
      group.querySelectorAll('[data-nv-option-value]').forEach(function (button) {
        var isAvailable = candidateAvailable(
          variants,
          selections,
          optionIndex,
          button.getAttribute('data-value')
        );
        button.disabled = !isAvailable;
        button.classList.toggle('is-unavailable', !isAvailable);
        button.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
      });
    });

    var price = sheet.querySelector('[data-nv-sheet-price]');
    if (price && variant) price.textContent = formatMoney(variant.price);

    syncMobileCarouselToVariant(sheet, variant, 'smooth');

    var add = sheet.querySelector('[data-nv-sheet-add]');
    var addText = sheet.querySelector('[data-nv-sheet-add-text]');
    var defaultText = add && add.getAttribute('data-default-text');
    var soldOutText = add && add.getAttribute('data-sold-out-text');
    var canAdd = !!(variant && variant.available);

    if (add) add.disabled = !canAdd;
    if (addText) addText.textContent = canAdd ? (defaultText || 'Quiero Pedirlo') : (soldOutText || 'Agotado');

    return variant;
  }

  function syncSheetFromNative(sheet) {
    var variants = getVariants(sheet);
    if (!variants.length) return false;
    if (hasMultiVariantUI(sheet)) {
      setSheetError(sheet, '');
      return syncMultiFromNative(sheet);
    }

    var currentId = nativeVariantId(sheet);
    var current = variants.find(function (variant) {
      return String(variant.id) === currentId;
    });
    if (!current) current = variants.find(function (variant) { return variant.available; }) || variants[0];
    if (current) setSheetSelectionFromVariant(sheet, current);

    var section = getProductSection(sheet);
    var nativeQty = section && section.querySelector('.product__quantity input[name="quantity"]');
    var sheetQty = sheet.querySelector('[data-nv-sheet-quantity]');
    if (nativeQty && sheetQty) {
      var qty = Math.max(1, parseInt(nativeQty.value, 10) || 1);
      sheetQty.value = qty;
    }

    setSheetError(sheet, '');
    updateSheetState(sheet);
    return true;
  }

  function selectSheetOption(button) {
    if (!button || button.disabled) return;
    var group = button.closest('[data-nv-option-group]');
    var sheet = button.closest('[data-nv-mobile-options-sheet]');
    if (!group || !sheet) return;

    group.querySelectorAll('[data-nv-option-value]').forEach(function (item) {
      var selected = item === button;
      item.classList.toggle('is-selected', selected);
      item.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
    setSheetError(sheet, '');
    updateSheetState(sheet);
  }

  function clampQuantity(input) {
    if (!input) return 1;
    var qty = parseInt(input.value, 10);
    if (!qty || qty < 1) qty = 1;
    input.value = qty;
    return qty;
  }

  function changeQuantity(sheet, delta) {
    var input = sheet && sheet.querySelector('[data-nv-sheet-quantity]');
    if (!input) return;
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
  }

  function addFromSheet(sheet, button) {
    if (!sheet || !button || button.getAttribute('aria-busy') === 'true') return;
    if (hasMultiVariantUI(sheet)) {
      addMultipleFromSheet(sheet, button);
      return;
    }

    var variant = updateSheetState(sheet);
    if (!variant || !variant.available) {
      setSheetError(sheet, 'Selecciona una opción disponible.');
      return;
    }

    var qtyInput = sheet.querySelector('[data-nv-sheet-quantity]');
    var quantity = clampQuantity(qtyInput);
    var form = getNativeForm(sheet);
    var data = form ? new FormData(form) : new FormData();
    data.set('id', String(variant.id));
    data.set('quantity', String(quantity));

    button.setAttribute('aria-busy', 'true');
    button.classList.add('btn--loading');
    button.disabled = true;
    setSheetError(sheet, '');

    var route = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';
    fetch(route, {
      method: 'POST',
      body: data,
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      }
    })
      .then(function (response) {
        return response.json().then(function (payload) {
          if (!response.ok || payload.status === 422) {
            var error = new Error(payload.description || payload.message || 'No se pudo agregar el producto.');
            error.payload = payload;
            throw error;
          }
          return payload;
        });
      })
      .then(function (product) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: product,
            addToCartBtn: button,
            novarisVariantId: variant.id
          }
        }));
      })
      .catch(function (error) {
        var message = (error && error.payload && error.payload.description) || error.message || 'No se pudo agregar el producto.';
        setSheetError(sheet, message);
        document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
          detail: { errorMessage: message }
        }));
      })
      .finally(function () {
        button.removeAttribute('aria-busy');
        button.classList.remove('btn--loading');
        // If the sheet is still open because of an error, restore its state.
        if (sheet === activeSheet) updateSheetState(sheet);
      });
  }

  function focusFirst(sheet) {
    if (!sheet) return;

    // Keep mobile keyboards closed when the options sheet opens.
    // Some browsers automatically open the numeric keyboard when a quantity
    // input receives programmatic focus. Focus the dialog close control instead.
    var active = document.activeElement;
    if (active && /^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName || '')) {
      active.blur();
    }

    var close = sheet.querySelector('.nv-mobile-options-sheet__close');
    if (close) {
      close.focus({ preventScroll: true });
      return;
    }

    // Accessibility fallback: focus a non-text control, never a quantity input.
    var selector = hasMultiVariantUI(sheet)
      ? '[data-nv-mobile-multi-preview]:not(:disabled), [data-nv-mobile-multi-toggle]:not(:disabled), [data-nv-sheet-add]:not(:disabled)'
      : '[data-nv-option-value]:not(:disabled), [data-nv-sheet-add]:not(:disabled)';
    var first = sheet.querySelector(selector);
    if (first) first.focus({ preventScroll: true });
  }

  function openSheet(sheet, trigger) {
    if (!mq.matches || !sheet || activeSheet) return;
    if (!syncSheetFromNative(sheet)) return;

    activeSheet = sheet;
    activeTrigger = trigger || null;
    window.clearTimeout(closeTimer);
    sheet.hidden = false;
    initMobileCarousel(sheet);
    initMobileLightbox(sheet);
    document.body.classList.add('nv-mobile-options-open');
    if (activeTrigger) activeTrigger.setAttribute('aria-expanded', 'true');

    window.requestAnimationFrame(function () {
      sheet.classList.add('is-open');
      window.setTimeout(function () {
        var carouselVariant = hasMultiVariantUI(sheet)
          ? variantById(sheet, sheet._nvLastMultiVariantId)
          : findVariant(sheet);
        syncMobileCarouselToVariant(sheet, carouselVariant, 'auto');
        focusFirst(sheet);
      }, 80);
    });
  }

  function closeSheet(options) {
    options = options || {};
    if (!activeSheet) return;

    var sheet = activeSheet;
    closeMobileLightbox(sheet);
    var trigger = activeTrigger;
    activeSheet = null;
    activeTrigger = null;

    sheet.classList.remove('is-open');
    document.body.classList.remove('nv-mobile-options-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');

    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(function () {
      sheet.hidden = true;
      if (options.restoreFocus !== false && trigger && visible(trigger)) {
        trigger.focus({ preventScroll: true });
      }
    }, 260);
  }

  function sheetForTrigger(trigger) {
    var bar = trigger && trigger.closest('[data-nv-mobile-buybar]');
    var id = bar && bar.getAttribute('data-nv-options-target');
    return id ? document.getElementById(id) : null;
  }

  function syncBar(bar) {
    if (!bar) return;
    var sectionId = bar.getAttribute('data-nv-product-section');
    var section = sectionId ? document.getElementById(sectionId) : null;
    if (!section) return;
    var sourcePrice = section.querySelector('[data-product-price]');
    var targetPrice = bar.querySelector('[data-nv-mobile-price]');
    if (sourcePrice && targetPrice && targetPrice.textContent !== sourcePrice.textContent) {
      targetPrice.textContent = sourcePrice.textContent;
    }
  }

  function nativePurchaseButton(bar) {
    if (!bar) return null;
    var sectionId = bar.getAttribute('data-nv-product-section');
    var section = sectionId ? document.getElementById(sectionId) : null;
    if (!section) return null;
    return section.querySelector('form.product-single__form [data-add-to-cart]');
  }

  function setBarViewportVisibility(bar, shouldShow) {
    if (!bar) return;
    bar.classList.toggle('is-visible', !!shouldShow);
    bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    document.documentElement.classList.toggle('nv-mobile-buybar-visible', !!shouldShow);
  }

  function disconnectPurchaseObserver(bar) {
    if (!bar || !bar._nvPurchaseVisibilityObserver) return;
    bar._nvPurchaseVisibilityObserver.disconnect();
    bar._nvPurchaseVisibilityObserver = null;
  }

  function initPurchaseVisibility(bar) {
    if (!bar) return;
    disconnectPurchaseObserver(bar);
    var sourceButton = nativePurchaseButton(bar);
    if (!sourceButton || !mq.matches) {
      setBarViewportVisibility(bar, false);
      return;
    }
    var frame = 0;
    var update = function () {
      frame = 0;
      var rect = sourceButton.getBoundingClientRect();
      var header = document.getElementById('SiteHeader');
      var headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      var buttonVisible = visible(sourceButton) && rect.bottom > headerBottom && rect.top < window.innerHeight;
      setBarViewportVisibility(bar, mq.matches && !buttonVisible);
    };
    var schedule = function () { if (!frame) frame = window.requestAnimationFrame(update); };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    var resize = window.ResizeObserver ? new ResizeObserver(schedule) : null;
    if (resize) { resize.observe(sourceButton); resize.observe(document.body); }
    bar._nvPurchaseVisibilityObserver = { disconnect: function () {
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      if (resize) resize.disconnect();
      if (frame) window.cancelAnimationFrame(frame);
    } };
    update();
  }


  function initBars(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-nv-mobile-buybar]').forEach(function (bar) {
      if (bar.getAttribute('data-nv-mobile-ready') === 'true') return;
      bar.setAttribute('data-nv-mobile-ready', 'true');
      syncBar(bar);
      initPurchaseVisibility(bar);

      var sectionId = bar.getAttribute('data-nv-product-section');
      var section = sectionId ? document.getElementById(sectionId) : null;
      if (section) {
        if (bar._nvSectionSyncObserver) bar._nvSectionSyncObserver.disconnect();
        var observer = new MutationObserver(function () { syncBar(bar); });
        observer.observe(section, { subtree: true, childList: true, characterData: true });
        bar._nvSectionSyncObserver = observer;
      }
    });
  }


  function rememberNativeChoice(event) {
    var target = event.target;
    var group = target && target.closest && target.closest('.variant-wrapper');
    if (!group) return;
    var section = group.closest('[data-section-type="product"]');
    if (section) section._nvNativeChoice = true;
  }
  document.addEventListener('click', rememberNativeChoice, true);
  document.addEventListener('change', rememberNativeChoice, true);

  document.addEventListener('click', function (event) {
    if (mq.matches && activeSheet) {
      var multiPreview = event.target.closest('[data-nv-mobile-multi-preview]');
      if (multiPreview && activeSheet.contains(multiPreview)) {
        event.preventDefault(); event.stopPropagation();
        var row = multiPreview.closest('[data-nv-mobile-multi-variant]');
        if (row && row.getAttribute('data-available') === 'true') toggleMultiRow(activeSheet, row);
        previewMultiRow(activeSheet, row, 'smooth');
        return;
      }
      var multiToggle = event.target.closest('[data-nv-mobile-multi-toggle]');
      if (multiToggle && activeSheet.contains(multiToggle)) {
        event.preventDefault();
        event.stopPropagation();
        toggleMultiRow(activeSheet, multiToggle.closest('[data-nv-mobile-multi-variant]'));
        return;
      }


      var multiMinus = event.target.closest('[data-nv-mobile-multi-qty-minus]');
      if (multiMinus && activeSheet.contains(multiMinus)) {
        event.preventDefault(); event.stopPropagation();
        changeMultiQuantity(activeSheet, multiMinus.closest('[data-nv-mobile-multi-variant]'), -1);
        return;
      }
      var multiPlus = event.target.closest('[data-nv-mobile-multi-qty-plus]');
      if (multiPlus && activeSheet.contains(multiPlus)) {
        event.preventDefault(); event.stopPropagation();
        changeMultiQuantity(activeSheet, multiPlus.closest('[data-nv-mobile-multi-variant]'), 1);
        return;
      }

      var optionButton = event.target.closest('[data-nv-option-value]');
      if (optionButton && activeSheet.contains(optionButton)) {
        event.preventDefault();
        event.stopPropagation();
        selectSheetOption(optionButton);
        return;
      }

      var minus = event.target.closest('[data-nv-sheet-qty-minus]');
      if (minus && activeSheet.contains(minus)) {
        event.preventDefault();
        event.stopPropagation();
        changeQuantity(activeSheet, -1);
        if (hasMultiVariantUI(activeSheet)) updateMultiState(activeSheet);
        return;
      }

      var plus = event.target.closest('[data-nv-sheet-qty-plus]');
      if (plus && activeSheet.contains(plus)) {
        event.preventDefault();
        event.stopPropagation();
        changeQuantity(activeSheet, 1);
        if (hasMultiVariantUI(activeSheet)) updateMultiState(activeSheet);
        return;
      }

      var sheetAdd = event.target.closest('[data-nv-sheet-add]');
      if (sheetAdd && activeSheet.contains(sheetAdd)) {
        event.preventDefault();
        event.stopPropagation();
        addFromSheet(activeSheet, sheetAdd);
        return;
      }

      var carouselPrev = event.target.closest('[data-nv-mobile-carousel-prev]');
      if (carouselPrev && activeSheet.contains(carouselPrev)) {
        event.preventDefault();
        event.stopPropagation();
        moveMobileCarousel(activeSheet, -1);
        return;
      }

      var carouselNext = event.target.closest('[data-nv-mobile-carousel-next]');
      if (carouselNext && activeSheet.contains(carouselNext)) {
        event.preventDefault();
        event.stopPropagation();
        moveMobileCarousel(activeSheet, 1);
        return;
      }

      if (event.target.closest('[data-nv-mobile-lightbox-close]')) {
        event.preventDefault();
        closeMobileLightbox(activeSheet);
        return;
      }

      if (event.target.closest('[data-nv-mobile-options-close]')) {
        event.preventDefault();
        closeSheet({ restoreFocus: true });
        return;
      }
    }

    var trigger = event.target.closest('[data-nv-mobile-buybar-open]');
    if (trigger && mq.matches) {
      event.preventDefault();
      event.stopPropagation();

      if (trigger.getAttribute('data-nv-mobile-action') === 'cart') {
        var cartTrigger = visibleCartTrigger();
        if (cartTrigger) cartTrigger.click();
        else window.location.href = '/cart';
        return;
      }

      var sheet = sheetForTrigger(trigger);
      if (sheet) {
        openSheet(sheet, trigger);
        return;
      }
    }

    // Remember an add initiated from the ORIGINAL product-page button.
    // It runs only when the independent options sheet is not open.
    if (mq.matches && !activeSheet) {
      var nativeAdd = event.target.closest('form.product-single__form [data-add-to-cart]');
      if (nativeAdd) {
        pendingNativeBar = null;
        pendingNativeButton = nativeAdd;
        document.querySelectorAll('[data-nv-mobile-buybar]').forEach(function (bar) {
          if (pendingNativeBar) return;
          var sectionId = bar.getAttribute('data-nv-product-section');
          var section = sectionId ? document.getElementById(sectionId) : null;
          if (section && section.contains(nativeAdd)) pendingNativeBar = bar;
        });
      }
    }
  }, true);

  document.addEventListener('input', function (event) {
    if (!mq.matches || !activeSheet || multiIsBusy(activeSheet)) return;
    var input = event.target.closest('[data-nv-mobile-multi-qty]');
    if (input && activeSheet.contains(input) && /^\d+$/.test(input.value) && Number(input.value) >= 1) {
      updateMultiState(activeSheet);
    }
  });

  document.addEventListener('change', function (event) {
    if (!mq.matches || !activeSheet) return;
    var multiQty = event.target.closest('[data-nv-mobile-multi-qty]');
    if (multiQty && activeSheet.contains(multiQty)) {
      clampMultiQuantity(multiQty);
      updateMultiState(activeSheet);
      return;
    }
    var qty = event.target.closest('[data-nv-sheet-quantity]');
    if (qty && activeSheet.contains(qty)) {
      clampQuantity(qty);
      if (hasMultiVariantUI(activeSheet)) updateMultiState(activeSheet);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (activeSheet && event.key === 'Escape') {
      event.preventDefault();
      var lb = mobileLightboxParts(activeSheet);
      if (lb && !lb.root.hidden) closeMobileLightbox(activeSheet);
      else closeSheet({ restoreFocus: true });
    }
  });

  document.addEventListener('ajaxProduct:added', function (event) {
    var button = event.detail && event.detail.addToCartBtn;

    // Add from the independent bottom options sheet.
    if (activeSheet && button && activeSheet.contains(button)) {
      var completedBar = activeTrigger && activeTrigger.closest('[data-nv-mobile-buybar]');
      setBarCartState(completedBar);
      pendingNativeBar = null;
      pendingNativeButton = null;

      closeSheet({ restoreFocus: false });
      return;
    }

    // Add from the original button on the product page.
    if (pendingNativeBar && (!pendingNativeButton || button === pendingNativeButton)) {
      setBarCartState(pendingNativeBar);
    }
    pendingNativeBar = null;
    pendingNativeButton = null;
  });

  document.addEventListener('cart:updated', function (event) {
    var cart = event.detail && event.detail.cart;
    if (cart && Number(cart.item_count) === 0) {
      document.querySelectorAll('[data-nv-mobile-buybar]').forEach(resetBarCartState);
    }
  });

  document.addEventListener('ajaxProduct:error', function () {
    pendingNativeBar = null;
    pendingNativeButton = null;
  });

  document.addEventListener('variant:change', function () {
    document.querySelectorAll('[data-nv-mobile-buybar]').forEach(syncBar);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initBars(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event && event.target;
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('[data-nv-mobile-buybar]').forEach(function (bar) {
      disconnectPurchaseObserver(bar);
      if (bar._nvSectionSyncObserver) {
        bar._nvSectionSyncObserver.disconnect();
        bar._nvSectionSyncObserver = null;
      }
    });
  });

  window.addEventListener('pagehide', function () {
    if (!activeSheet) return;
    activeSheet.classList.remove('is-open');
    document.body.classList.remove('nv-mobile-options-open');
    activeSheet.hidden = true;
    activeSheet = null;
    activeTrigger = null;
  });

  var onMqChange = function (event) {
    if (!event.matches && activeSheet) closeSheet({ restoreFocus: false });
    document.querySelectorAll('[data-nv-mobile-buybar]').forEach(function (bar) {
      initPurchaseVisibility(bar);
    });
  };
  if (mq.addEventListener) mq.addEventListener('change', onMqChange);
  else mq.addListener(onMqChange);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initBars(document);
      initCartDrawerWatcher();
    });
  } else {
    initBars(document);
    initCartDrawerWatcher();
  }

  window.NovarisMobileStickyBuy = {
    version: '1.10.0',
    close: closeSheet
  };
})();
